import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api, { setToken, getToken, setProfileKind } from "@/lib/api";
import { isAllowedUser, userKind, isApproved } from "@/lib/permissions";
import { queryClient } from "@/lib/queryClient";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    if (!getToken()) {
      setProfileKind(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      if (isAllowedUser(data)) {
        setProfileKind(userKind(data));
        setUser(data);
      } else {
        setProfileKind(null);
        setToken(null);
        setUser(null);
      }
    } catch {
      setProfileKind(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    const u = data?.user || {};
    if (!userKind(u)) {
      const e = new Error(
        "Acesso restrito ao app mobile. Somente perfis Gestor ou Administrativo podem acessar o painel web.",
      );
      e.code = "ROLE_BLOCKED";
      throw e;
    }
    if (!isApproved(u)) {
      const e = new Error(
        "Seu cadastro ainda não foi aprovado no app. Fale com o gestor da sua empresa.",
      );
      e.code = "ROLE_BLOCKED";
      throw e;
    }
    setToken(data.access_token);
    queryClient.clear();
    setProfileKind(userKind(u));
    setUser(u);
    return u;
  };

  const logout = () => {
    queryClient.clear();
    setProfileKind(null);
    setToken(null);
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, reload: loadMe }}>
      {children}
    </AuthCtx.Provider>
  );
}
